// @wc-ignore-file
import type { Notification } from "./notifications.types";

type JoinRequestType = Extract<
  Notification["type"],
  "project_join_requested" | "project_join_approved" | "project_join_rejected"
>;

export type JoinRequestTarget =
  | {
      to: "/workspaces/$slug/projects/$projectSlug/members";
      params: { slug: string; projectSlug: string };
    }
  | { to: "/workspaces/$slug/projects/$projectSlug"; params: { slug: string; projectSlug: string } }
  | { to: "/workspaces/$slug/projects"; params: { slug: string } };

export function isJoinRequestNotification(
  notification: Pick<Notification, "type">,
): notification is Pick<Notification, "type"> & { type: JoinRequestType } {
  return (
    notification.type === "project_join_requested" ||
    notification.type === "project_join_approved" ||
    notification.type === "project_join_rejected"
  );
}

/**
 * CR-203: where a join-request notification leads. The owner reviews requests
 * on the project's members page; an approved requester opens the project; a
 * declined one lands on the workspace's project list, where the card offers
 * "Request again" (the project itself is closed to them).
 * KEEP IN SYNC with resolveNotificationUrl in
 * backend/api-server/src/routes/notification-email-worker.ts.
 */
export function joinRequestTarget(
  type: JoinRequestType,
  slugs: { workspaceSlug: string; projectSlug: string },
): JoinRequestTarget {
  switch (type) {
    case "project_join_requested":
      return {
        to: "/workspaces/$slug/projects/$projectSlug/members",
        params: { slug: slugs.workspaceSlug, projectSlug: slugs.projectSlug },
      };
    case "project_join_approved":
      return {
        to: "/workspaces/$slug/projects/$projectSlug",
        params: { slug: slugs.workspaceSlug, projectSlug: slugs.projectSlug },
      };
    case "project_join_rejected":
      return { to: "/workspaces/$slug/projects", params: { slug: slugs.workspaceSlug } };
  }
}
